import React, { FC } from 'react';
import { SkippableFragment } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { RecapSkipButtonGroup } from './component';

interface FilterProps {
    className?: string;
    currentFragment: SkippableFragment | undefined;
}

export const RecapSkipButtonGroupContainer: FC<FilterProps> = ({ currentFragment, ...rest }) => {
    if (currentFragment?.type === 'RECAP') {
        return <RecapSkipButtonGroup currentFragment={currentFragment} {...rest} />;
    }

    return null;
};
